// /ops/log — технический журнал. Право — ops.log.read: только сопровождение (FR-032, FR-049).
// Номер операции — в адресе: /ops/log?operation=7F3K-92QD-1A2B (ссылка из «Фоновых задач»).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { LogPage } from '../../features/ops/LogPage.tsx';
import { parseLogSearch } from '../../features/ops/log-search.ts';
import type { LogSearch } from '../../features/ops/log-search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/ops/log')({
  validateSearch: parseLogSearch,
  beforeLoad: requireSection('log'),
  staticData: { crumb: 'Технический журнал' },
  component: LogRoute,
});

function LogRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: LogSearch) => void navigate({ to: '/ops/log', search: next, replace: true }),
    [navigate],
  );
  return <LogPage search={search} onSearchChange={onSearchChange} />;
}
